/**
 * Product Recommendations Section JavaScript
 *
 * Handles:
 * 1. Slick carousel initialisation for the related products slider.
 * 2. Immediate fetch from Shopify's Product Recommendations API on page load
 *    (only when source === 'api'). The section is re-fetched via the
 *    recommendations endpoint, which re-renders it with the
 *    `recommendations` object populated. The carousel HTML is then
 *    swapped, the slider re-initialised, and AOS animations refreshed.
 */

(function () {
  'use strict';

  var SLIDER_SELECTOR = '.js-related-products';
  var SLIDER_OPTIONS = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  /**
   * Initialise (or re-initialise) the Slick slider on a carousel element.
   * @param {Element} carouselEl
   */
  function initSlider(carouselEl) {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var $carousel = jQuery(carouselEl);

    // Destroy any existing instance before re-initialising
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }

    // Only initialise if there are actual slide children
    var slides = carouselEl.querySelectorAll(
      '.product-highlight-grid__card:not(.product-highlight-grid__card--skeleton)'
    );
    if (slides.length === 0) return;

    $carousel.slick(SLIDER_OPTIONS);
  }

  /**
   * Fetch the section HTML via the Recommendations API endpoint.
   * Shopify re-renders the section with `recommendations` populated.
   * We then swap the carousel content, re-initialise the slider,
   * and refresh AOS so newly injected data-aos elements animate.
   * @param {Element} carouselEl
   */
  function fetchAndSwap(carouselEl) {
    var url = carouselEl.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('[product-recommendations] Fetch failed: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fetchedCarousel = doc.querySelector(SLIDER_SELECTOR);

        if (!fetchedCarousel) return;

        // Bail if no real product cards came back
        var fetchedCards = fetchedCarousel.querySelectorAll(
          '.product-highlight-grid__card:not(.product-highlight-grid__card--skeleton)'
        );
        if (fetchedCards.length === 0) return;

        // Destroy existing slider instance before swapping HTML
        if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
          var $carousel = jQuery(carouselEl);
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }
        }

        // Swap content and re-initialise
        carouselEl.innerHTML = fetchedCarousel.innerHTML;
        initSlider(carouselEl);

        // Refresh AOS so newly injected data-aos elements animate
        if (typeof AOS !== 'undefined') {
          AOS.refresh();
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  /**
   * Set up a single recommendations carousel element.
   * @param {Element} carouselEl
   */
  function setup(carouselEl) {
    var source = carouselEl.dataset.source;

    if (source === 'api') {
      // Fetch immediately — no lazy loading
      fetchAndSwap(carouselEl);
    } else {
      // collection / manual — content is already rendered server-side
      initSlider(carouselEl);
    }
  }

  /**
   * Entry point — runs after DOM is ready.
   */
  function init() {
    var carousels = document.querySelectorAll(SLIDER_SELECTOR);
    carousels.forEach(function (el) {
      setup(el);
    });

    // Support Shopify theme editor section:load events
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (!section) return;
      var carousel = section.querySelector(SLIDER_SELECTOR);
      if (carousel) setup(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

